import React, { Component } from 'react';
import { Icon } from '@mgc/react-components';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import PropTypes from 'prop-types';
import selectors from '../../../selectors';
import UiActions from '../../../actions/ui';
import MapPropTypes from '../../MapPropTypes';
import strings from '../../../strings';
import utils from '../../../utils';
import ModalBase from '../Base';
import PriceTable from './PriceTable';
import './PricingModal.scss';

class PricingModal extends Component {
    static propTypes = {
        offer: MapPropTypes.OfferProps,
        visible: PropTypes.bool.isRequired,
        close: PropTypes.func.isRequired,
    };

    static mapState = (state) =>
        mapSelectors(state, {
            offer: selectors.offer.getSelectedOffer,
            visible: selectors.ui.getPricingModalVisible,
        });

    static mapDispatch = (dispatch) => ({
        close: () => dispatch(UiActions.closeModal('pricing')),
    });

    render() {
        const { offer, visible, close } = this.props;

        if (!offer) {
            return <div />;
        }

        const title = (
            <span>
                {strings.pricingForOffer}: {offer.mentorId} -{' '}
                {offer.account.name}{' '}
                <span className="text-mute p-l text-normal">
                    <Icon name="icon-calendar" />{' '}
                    {utils.formatShortDate(offer.validFrom)} -{' '}
                    {utils.formatShortDate(offer.validTo)}
                </span>
            </span>
        );

        return (
            <ModalBase
                modalClassName="pricing-modal"
                modalTitle={title}
                visible={visible}
                closeModal={close}
            >
                <PriceTable pricing={offer.pricing} />
            </ModalBase>
        );
    }
}

export default attach(PricingModal);



// WEBPACK FOOTER //
// ./app/components/Modals/PricingModal/index.jsx